import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotateXSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M85.84,59.65v29.5H37.28v-14H63.16c4,0,10.19-15.53,15.32-15.53Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M62.72,57.89v14H36.84c-4,0-10.19,15.52-15.32,15.52H14.16V57.89Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M69.39,48.38a1.33,1.33,0,1,0,0-2.66A15.12,15.12,0,1,1,83.75,25.87L82.1,24.43l.26,3.8,3.52,3.08L89,27.79,88.72,24l-2.07,2.36a17.77,17.77,0,1,0-17.26,22Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M85.84,58.53H78.48c-3.33,0-6.49,4.58-9.56,9-1.9,2.75-4.5,6.51-5.76,6.51H37.28a1.12,1.12,0,0,0-1.12,1.12v14a1.12,1.12,0,0,0,2.24,0V76.3H63.16c2.43,0,4.72-3.3,7.61-7.48,2.48-3.58,5.56-8,7.71-8h6.23V89.15a1.13,1.13,0,0,0,2.25,0V59.65A1.12,1.12,0,0,0,85.84,58.53Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M62.72,73a1.12,1.12,0,0,0,1.12-1.12v-14a1.12,1.12,0,0,0-2.24,0V70.74H36.84c-2.43,0-4.72,3.3-7.61,7.48-2.48,3.58-5.56,8-7.71,8H15.29V57.89a1.13,1.13,0,0,0-2.25,0V87.38a1.13,1.13,0,0,0,1.12,1.13h7.36c3.33,0,6.49-4.58,9.56-9C33,76.75,35.58,73,36.84,73Z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-highlight",
			points: "81.05 41 86.22 33.86 82.22 33.86 78.99 38.39 75.73 33.86 71.62 33.86 76.81 41.09 71.33 48.61 75.48 48.61 78.92 43.75 82.39 48.61 86.58 48.61 81.05 41"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M40.6,87.82H37.28a1.33,1.33,0,0,0,0,2.66H40.6a1.33,1.33,0,0,0,0-2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M60.53,87.82H57.21a1.33,1.33,0,1,0,0,2.66h3.32a1.33,1.33,0,0,0,0-2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M47.24,87.82H43.92a1.33,1.33,0,0,0,0,2.66h3.32a1.33,1.33,0,0,0,0-2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M85.84,87.82H83.77a1.33,1.33,0,0,0,0,2.66h2.07a1.33,1.33,0,0,0,0-2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M53.89,87.82H50.56a1.33,1.33,0,0,0,0,2.66h3.33a1.33,1.33,0,0,0,0-2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M73.81,87.82H70.49a1.33,1.33,0,1,0,0,2.66h3.32a1.33,1.33,0,0,0,0-2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M67.17,87.82H63.85a1.33,1.33,0,0,0,0,2.66h3.32a1.33,1.33,0,0,0,0-2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M80.45,87.82H77.13a1.33,1.33,0,0,0,0,2.66h3.32a1.33,1.33,0,0,0,0-2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M37.48,57.89a1.33,1.33,0,0,0-1.33-1.33H32.83a1.33,1.33,0,0,0,0,2.66h3.32A1.33,1.33,0,0,0,37.48,57.89Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M29.51,56.56H26.19a1.33,1.33,0,0,0,0,2.66h3.32a1.33,1.33,0,1,0,0-2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M22.87,56.56H19.55a1.33,1.33,0,0,0,0,2.66h3.32a1.33,1.33,0,1,0,0-2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M16.23,56.56H14.16a1.33,1.33,0,0,0,0,2.66h2.07a1.33,1.33,0,1,0,0-2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M59.4,59.22h3.32a1.33,1.33,0,0,0,0-2.66H59.4a1.33,1.33,0,1,0,0,2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M39.47,59.22h3.32a1.33,1.33,0,1,0,0-2.66H39.47a1.33,1.33,0,0,0,0,2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M52.76,59.22h3.32a1.33,1.33,0,0,0,0-2.66H52.76a1.33,1.33,0,0,0,0,2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M46.11,59.22h3.33a1.33,1.33,0,1,0,0-2.66H46.11a1.33,1.33,0,0,0,0,2.66Z"
		})
	]
});
export default SvgRotateXSm;
